import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PrivacyBadge from '../components/PrivacyBadge';
import Hero from '../components/landing/Hero';
import ProblemSolution from '../components/landing/ProblemSolution';
import FeatureShowcase from '../components/landing/FeatureShowcase';
import Bonuses from '../components/landing/Bonuses';
import HowItWorks from '../components/landing/HowItWorks';
import Pricing from '../components/landing/Pricing';
import Testimonials from '../components/landing/Testimonials';
import ShareMyPartyPicsPromo from '../components/landing/ShareMyPartyPicsPromo';
import FAQ from '../components/landing/FAQ';

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FBF7F2]">
      <Navbar />
      <main>
        <Hero />
        <PrivacyBadge variant="banner" />
        <ProblemSolution />
        <FeatureShowcase />
        <Bonuses />
        <HowItWorks />
        <Pricing />
        <Testimonials />
        <ShareMyPartyPicsPromo />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
